export enum EUserCardTabs {
    PROFILE = 'Профиль',
    PAYMENT = 'Платежный счет',
    PERSONAL = 'Лицевой счет',
    // GREEN_TOOLS_USERS = 'ЗИ пользователя',
    // GO_USERS = 'ГО пользователя',
}
export type CurrentTab = EUserCardTabs
